(function () {
  'use strict';

  // Cada tema agrupa varias formas reales de preguntar lo mismo.
  // Todas las respuestas usan únicamente datos verificados de La Droguería / Cash Chari.
  var TOPICS = [
    {
      id: 'horario',
      triggers: ['horario', 'horarios', 'a que hora abren', 'a que hora abris', 'a que hora cierran', 'hasta que hora', 'estan abiertos', 'estais abiertos', 'abierto hoy', 'domingo abierto', 'fin de semana horario'],
      answer: 'De lunes a jueves abrimos de 9:00 a 15:00 y de 17:00 a 21:30. De viernes a domingo tenemos horario continuo de 9:00 a 21:30.'
    },
    {
      id: 'tiendas',
      triggers: ['donde estais', 'donde esta la tienda', 'direccion', 'direcciones', 'tienda fisica', 'tiendas fisicas', 'torre del mar', 'motril', 'como llegar', 'ubicacion', 'localizacion', 'donde puedo recoger'],
      answer: 'Tenemos tienda física en Calle del Mar (junto a Chari Express), Torre del Mar, y en la Costa Tropical, Motril. Puedes ver el mapa de cada una en la sección "Encuentra tu droguería más cercana" de la portada.'
    },
    {
      id: 'contacto',
      triggers: ['telefono', 'contacto', 'como os contacto', 'como llamo', 'numero de telefono', 'whatsapp', 'hablar con alguien', 'atencion al cliente'],
      answer: 'Puedes llamarnos al 952 54 26 39. También nos tienes en Facebook, Instagram y TikTok como Cash Chari, en la sección "Síguenos" de la portada.'
    },
    {
      id: 'marcas',
      triggers: ['marcas', 'primeras marcas', 'ariel', 'pantene', 'fairy', 'tampax', 'garnier', 'loreal', 'marca original', 'productos originales', 'es original'],
      answer: 'Sí, trabajamos con las marcas nacionales que ya conoces y en las que confías: Ariel, Pantene, Fairy, Tampax y muchas más. Las tienes todas en la sección "Marcas que ya conoces" de la portada.'
    },
    {
      id: 'mayorista',
      triggers: ['mayorista', 'negocio', 'comprar para mi negocio', 'precio profesional', 'precio de mayorista', 'compro para un bar', 'compro para mi comercio', 'al por mayor'],
      answer: 'Sí. Como parte de Cash Chari, aplicamos precio de mayorista tanto si compras para tu casa como para tu negocio: pagas lo mismo que un profesional.'
    },
    {
      id: 'pago',
      triggers: ['metodos de pago', 'como pago', 'formas de pago', 'aceptais tarjeta', 'paypal', 'pago seguro', 'con que puedo pagar'],
      answer: 'El pago se realiza de forma segura en el checkout de la tienda, con tarjeta, PayPal y el resto de métodos disponibles en ese momento.'
    },
    {
      id: 'envio',
      triggers: ['envio', 'envios', 'gastos de envio', 'cuanto cuesta el envio', 'cuando llega', 'plazo de entrega', 'entrega a domicilio', 'mandais a casa', 'hacer pedido online'],
      answer: 'Los gastos y el plazo de envío se calculan automáticamente en el checkout, antes de pagar, según tu dirección. También puedes consultar la Política de envío en el pie de la tienda.'
    },
    {
      id: 'devoluciones',
      triggers: ['devolucion', 'devoluciones', 'reembolso', 'como devuelvo', 'cambiar un producto', 'no me gusto el producto', 'quiero devolver'],
      answer: 'Consulta nuestra Política de reembolso, disponible en el pie de página de la tienda, con todos los detalles sobre devoluciones.'
    },
    {
      id: 'redes',
      triggers: ['instagram', 'facebook', 'tiktok', 'redes sociales', 'seguirnos', 'donde os sigo'],
      answer: 'Nos puedes seguir en Facebook, Instagram y TikTok como Cash Chari. Tienes los enlaces directos en la sección "Síguenos" de la portada.'
    },
    {
      id: 'catalogo',
      triggers: ['catalogo', 'categorias', 'que productos teneis', 'que vendeis', 'lavanderia', 'limpieza', 'lavavajillas', 'higiene', 'papel', 'piscinas', 'cuidado personal'],
      answer: 'Tenemos más de 90 referencias en lavandería, limpieza del hogar, lavavajillas, cuidado personal (con desodorantes), higiene, papel y celulosa, y piscinas. Puedes verlo todo en "Ver catálogo completo" desde la portada.'
    },
    {
      id: 'quienes',
      triggers: ['quienes sois', 'quien sois', 'historia', 'desde cuando existis', 'cash chari', 'sobre vosotros', 'empresa familiar'],
      answer: 'Somos LA DROGUERÍA, la tienda online de Cash Chari, una empresa familiar en activo desde 2018.'
    },
    {
      id: 'cuenta',
      triggers: ['crear cuenta', 'iniciar sesion', 'mi cuenta', 'registrarme', 'como me registro'],
      answer: 'Puedes crear una cuenta o iniciar sesión desde el icono de usuario, arriba de la tienda, junto al buscador.'
    },
    {
      id: 'carrito',
      triggers: ['carrito', 'como compro', 'añadir al carrito', 'agregar al carrito', 'finalizar compra', 'como hago un pedido'],
      answer: 'Añade productos con el botón "Agregar al carrito" en cada ficha y finaliza la compra desde el icono de la cesta, arriba a la derecha.'
    },
    {
      id: 'stock',
      triggers: ['hay stock', 'disponible', 'agotado', 'queda stock', 'sin stock'],
      answer: 'La disponibilidad se muestra en cada ficha de producto. Si aparece "Agotado", ese producto no está disponible ahora mismo.'
    },
    {
      id: 'factura',
      triggers: ['factura', 'pedir factura', 'necesito una factura', 'datos de facturacion', 'factura con nif'],
      answer: 'Puedes indicar tus datos de facturación al finalizar la compra, en el checkout.'
    },
    {
      id: 'descuento',
      triggers: ['cupon', 'codigo de descuento', 'descuento', 'oferta', 'promocion', 'rebajas'],
      answer: 'Ahora mismo no tenemos códigos de descuento activos, pero aplicamos precio de mayorista en todos los productos, compres para casa o para tu negocio.'
    },
    {
      id: 'cancelar_pedido',
      triggers: ['cancelar pedido', 'anular pedido', 'modificar mi pedido', 'cambiar mi pedido', 'he comprado mal'],
      answer: 'Escríbenos lo antes posible al 952 54 26 39 y te ayudamos a cancelar o modificar tu pedido.'
    },
    {
      id: 'seguimiento',
      triggers: ['seguimiento del pedido', 'donde esta mi pedido', 'estado de mi pedido', 'confirmacion de pedido'],
      answer: 'En cuanto se procesa tu pedido recibes un email de confirmación con todos los detalles.'
    },
    {
      id: 'reponer_stock',
      triggers: ['cuando repondreis', 'cuando volvera a haber', 'cuando restock', 'reponer producto'],
      answer: 'Los productos agotados vuelven a estar disponibles en cuanto reponemos stock. Puedes consultarlo de nuevo más adelante en su ficha.'
    },
    {
      id: 'piscinas_cat',
      triggers: ['productos para piscina', 'cloro piscina', 'tenéis piscinas', 'mantenimiento de piscina'],
      answer: 'Sí, tenemos cloro, pastillas y todo lo necesario para el mantenimiento de tu piscina en la categoría Piscinas.'
    },
    {
      id: 'papel_cat',
      triggers: ['papel higienico', 'tenéis papel', 'celulosa', 'papel de cocina'],
      answer: 'Sí, tenemos papel higiénico y celulosa de varias marcas en la categoría Papel y celulosa.'
    },
    {
      id: 'detergente_cat',
      triggers: ['que detergentes teneis', 'detergente para lavadora', 'suavizante ropa', 'productos de lavanderia'],
      answer: 'Tenemos detergentes, suavizantes y productos de lavandería de varias marcas y formatos en la categoría Lavandería.'
    },
    {
      id: 'limpieza_cat',
      triggers: ['productos de limpieza', 'limpieza del hogar', 'limpiar la casa', 'friegasuelos', 'lejia'],
      answer: 'Sí, tenemos friegasuelos, lejía y todo tipo de productos de limpieza del hogar en la categoría Limpieza del hogar.'
    },
    {
      id: 'seguridad_web',
      triggers: ['es seguro comprar', 'pagina segura', 'es de fiar esta tienda', 'compra segura'],
      answer: 'Sí, el pago se procesa de forma segura mediante el checkout cifrado de Shopify.'
    },
    {
      id: 'idioma',
      triggers: ['esta en español', 'idioma de la tienda', 'hay version en ingles'],
      answer: 'Sí, toda la tienda está en español.'
    },
    {
      id: 'zona_envio',
      triggers: ['enviais a toda españa', 'zona de envio', 'enviais fuera de españa', 'envio internacional'],
      answer: 'La zona de envío disponible para tu dirección se muestra automáticamente al llegar al checkout.'
    },
    {
      id: 'recogida_tienda',
      triggers: ['recoger en tienda', 'recogida en tienda', 'puedo recoger mi pedido'],
      answer: 'Escríbenos al 952 54 26 39 y te confirmamos si es posible recoger tu pedido en alguna de nuestras tiendas.'
    },
    {
      id: 'horario_online',
      triggers: ['puedo comprar a cualquier hora', 'horario tienda online', 'esta abierta la web ahora'],
      answer: 'Sí, la tienda online está abierta las 24 horas, todos los días. Solo las tiendas físicas tienen horario.'
    },
    {
      id: 'variantes',
      triggers: ['como elijo el formato', 'como elijo la variante', 'tallas', 'que formatos hay'],
      answer: 'Selecciona el formato o variante disponible directamente en la ficha del producto, antes de añadirlo al carrito.'
    },
    {
      id: 'invitado',
      triggers: ['necesito registrarme para comprar', 'puedo comprar sin cuenta', 'comprar como invitado'],
      answer: 'No es obligatorio. Puedes comprar como invitado, aunque crear una cuenta te permite ver tu historial de pedidos.'
    },
    {
      id: 'ubicacion_general',
      triggers: ['donde esta cash chari', 'en que zona estais', 'axarquia', 'costa tropical'],
      answer: 'Cash Chari tiene droguerías en la Axarquía y la Costa Tropical, con tiendas físicas en Torre del Mar y Motril.'
    },
    {
      id: 'precio_igual',
      triggers: ['el precio es igual online que en tienda', 'mismo precio tienda fisica', 'precio diferente online'],
      answer: 'Aplicamos precio de mayorista tanto online como en nuestras tiendas físicas.'
    },
    {
      id: 'higiene_cat',
      triggers: ['productos de higiene', 'compresas', 'toallitas', 'cuidado personal productos'],
      answer: 'Sí, tenemos productos de higiene y cuidado personal de primeras marcas en sus categorías correspondientes.'
    },
    {
      id: 'desodorantes_cat',
      triggers: ['desodorante', 'desodorantes', 'tenéis axe', 'tenéis byly', 'antitranspirante', 'roll on', 'roll-on'],
      answer: 'Sí, tenemos un montón de desodorantes en spray y roll-on de AXE, BYLY, L\'Oréal Men Expert y Palmolive, en la categoría Cuidado personal.'
    },
    {
      id: 'gel_champu_cat',
      triggers: ['gel de baño', 'geles de baño', 'que champus teneis', 'champú', 'cuidado capilar'],
      answer: 'Sí, tenemos champús (Pantene, Elvive, Fructis) y geles de baño de varias marcas en la categoría Cuidado personal.'
    },
    {
      id: 'moneda',
      triggers: ['en que moneda', 'pago en euros', 'moneda de la tienda'],
      answer: 'Todos los precios de la tienda están en euros (€).'
    },
    {
      id: 'direccion_almacen',
      triggers: ['desde donde enviais', 'donde esta el almacen', 'direccion de cash chari', 'donde esta cash chari exactamente'],
      answer: 'Cash Chari tiene sus instalaciones en el Polígono Industrial La Pañoleta, C/ Bartolomé Esteban Murillo nº 4, además de las tiendas de Torre del Mar y Motril.'
    },
    {
      id: 'num_tiendas',
      triggers: ['cuantas tiendas teneis', 'cuantas tiendas fisicas', 'numero de tiendas'],
      answer: 'Tenemos 4 tiendas en la Axarquía y la Costa Tropical, como parte de Cash Chari, empresa familiar desde 2018.'
    },
    {
      id: 'hablar_persona',
      triggers: ['eres un robot', 'eres una ia', 'quiero hablar con una persona', 'quiero hablar con alguien real', 'no eres humano'],
      answer: 'Soy un asistente automático con información real de la tienda. Si prefieres hablar con una persona, llámanos al 952 54 26 39.'
    },
    {
      id: 'producto_no_encontrado',
      triggers: ['no encuentro un producto', 'no encuentro lo que busco', 'busco un producto y no aparece'],
      answer: 'Prueba a buscarlo con la lupa de arriba de la tienda. Si aun así no lo encuentras, llámanos al 952 54 26 39 y te decimos si lo tenemos.'
    },
    {
      id: 'cambiar_direccion',
      triggers: ['cambiar direccion de envio', 'me equivoque de direccion', 'direccion incorrecta pedido'],
      answer: 'Escríbenos cuanto antes al 952 54 26 39 si necesitas cambiar la dirección de un pedido ya realizado.'
    },
    {
      id: 'saludo',
      triggers: ['hola', 'buenas', 'buenos dias', 'buenas tardes', 'ey', 'hey'],
      answer: '¡Hola de nuevo! ¿En qué más te puedo ayudar?'
    },
    {
      id: 'agradecimiento',
      triggers: ['gracias', 'vale gracias', 'muchas gracias', 'perfecto gracias'],
      answer: '¡De nada! Si necesitas cualquier otra cosa, aquí estoy.'
    },
    {
      id: 'despedida',
      triggers: ['adios', 'chao', 'hasta luego', 'nos vemos'],
      answer: '¡Hasta pronto! Gracias por visitar LA DROGUERÍA.'
    }
  ];

  var GREETING = '¡Hola! 👋 Soy el asistente de LA DROGUERÍA. Puedo ayudarte con horarios, tiendas, envíos, pago, marcas y más. ¿Qué quieres saber?';
  var FALLBACK = 'No tengo una respuesta exacta para eso todavía. Puedes llamarnos al 952 54 26 39 o escribirnos por Instagram/Facebook/TikTok como Cash Chari, y te ayudamos encantados.';
  var SUGGESTIONS = ['horario', 'tiendas', 'envio', 'devoluciones', 'marcas', 'mayorista'];

  function normalize(str) {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function findAnswer(rawText) {
    var text = normalize(rawText);
    if (!text) return null;
    var best = null;
    var bestScore = 0;
    for (var i = 0; i < TOPICS.length; i++) {
      var topic = TOPICS[i];
      for (var j = 0; j < topic.triggers.length; j++) {
        var trigger = topic.triggers[j];
        if (text.indexOf(trigger) !== -1) {
          var score = trigger.length;
          if (score > bestScore) {
            bestScore = score;
            best = topic.answer;
          }
        }
      }
    }
    return best;
  }

  function init() {
    var root = document.querySelector('[data-drogueria-chatbot]');
    if (!root) return;

    var launcher = root.querySelector('[data-chatbot-launcher]');
    var panel = root.querySelector('[data-chatbot-panel]');
    var messages = root.querySelector('[data-chatbot-messages]');
    var form = root.querySelector('[data-chatbot-form]');
    var input = root.querySelector('[data-chatbot-input]');
    var suggestionsWrap = root.querySelector('[data-chatbot-suggestions]');
    var greeted = false;

    function addMessage(text, who) {
      var bubble = document.createElement('div');
      bubble.className = 'drogueria-chatbot__msg drogueria-chatbot__msg--' + who;
      bubble.textContent = text;
      messages.appendChild(bubble);
      messages.scrollTop = messages.scrollHeight;
      return bubble;
    }

    function showTyping() {
      var bubble = document.createElement('div');
      bubble.className = 'drogueria-chatbot__msg drogueria-chatbot__msg--bot drogueria-chatbot__msg--typing';
      bubble.innerHTML =
        '<span class="drogueria-chatbot__dot"></span>' +
        '<span class="drogueria-chatbot__dot"></span>' +
        '<span class="drogueria-chatbot__dot"></span>';
      messages.appendChild(bubble);
      messages.scrollTop = messages.scrollHeight;
      return bubble;
    }

    function respond(text) {
      addMessage(text, 'user');
      var answer = findAnswer(text) || FALLBACK;
      var typingBubble = showTyping();
      var delay = 500 + Math.min(answer.length * 12, 1400) + Math.random() * 300;
      window.setTimeout(function () {
        typingBubble.remove();
        addMessage(answer, 'bot');
      }, delay);
    }

    function openPanel() {
      root.classList.add('is-open');
      launcher.setAttribute('aria-expanded', 'true');
      if (!greeted) {
        greeted = true;
        addMessage(GREETING, 'bot');
      }
      window.setTimeout(function () {
        input.focus();
      }, 150);
    }

    function closePanel() {
      root.classList.remove('is-open');
      launcher.setAttribute('aria-expanded', 'false');
    }

    launcher.addEventListener('click', function () {
      if (root.classList.contains('is-open')) {
        closePanel();
      } else {
        openPanel();
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var value = input.value.trim();
      if (!value) return;
      respond(value);
      input.value = '';
    });

    if (suggestionsWrap) {
      suggestionsWrap.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-chatbot-chip]');
        if (!chip) return;
        respond(chip.textContent.trim());
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) {
        closePanel();
      }
    });

    window.addEventListener('click', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (root.contains(e.target)) return;
      closePanel();
    });

    root.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    void SUGGESTIONS;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
